export default __webpack_public_path__ + "static/media/SEC2070.34I-43593_-26021_0.75d2e647.jpg";